import { Model } from 'dva'
import { FlowsService } from '../../Service'
import { IsObject } from '../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { InteractiveDemo } from './types'

const InteractiveDemos: Model = {
  namespace: 'interactiveDemos',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let interactiveDemos = yield select((state: any) => state.interactiveDemos.list)
        if (!(interactiveDemos.length > 0 && useCache)) {
          interactiveDemos = yield call(FlowsService.flowsList, {
            organisationName: 'Skit Engage',
          })
          yield put({ type: 'modifyList', payload: interactiveDemos })
        }
        onSuccess(interactiveDemos)
      } catch (err: any) {
        FailureHandler('Error fetching Interactive Demos', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { uuid, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let interactiveDemo = yield select((state: any) =>
          state.interactiveDemos.list.find(
            (interactiveDemo: InteractiveDemo) => interactiveDemo.uuid === uuid
          )
        )
        if (!interactiveDemo) {
          interactiveDemo = yield call(FlowsService.flowsRetrieve, {
            flowUuid: uuid,
          })
        }
        yield put({ type: 'modifyList', payload: interactiveDemo })
        onSuccess(interactiveDemo)
      } catch (err) {
        FailureHandler('Could not find the Interactive Demo!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { uuid, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ): any {
      setLoading(true)
      try {
        const response = yield call(FlowsService.flowsPartialUpdate, {
          flowUuid: uuid,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a Interactive Demo', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: InteractiveDemo) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter(
            (l: InteractiveDemo) => !action.payload.map((p: InteractiveDemo) => p.id).includes(l.id)
          )
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: InteractiveDemo) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetInteractiveDemos(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default InteractiveDemos
